import { render, staticRenderFns } from "./multiple-image-upload.vue?vue&type=template&id=3e96b578&scoped=true"
import script from "./multiple-image-upload.vue?vue&type=script&lang=ts"
export * from "./multiple-image-upload.vue?vue&type=script&lang=ts"
import style0 from "./multiple-image-upload.vue?vue&type=style&index=0&id=3e96b578&prod&lang=stylus&module=true"
import style1 from "./multiple-image-upload.vue?vue&type=style&index=1&id=3e96b578&prod&lang=stylus&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3e96b578",
  null
  
)

export default component.exports